import { Text } from '@doda/io-react/common';
import { LinkBox } from '@doda/common/src/logics/seoFooterLinkData/createSeoFooterLink';
import styles from '../../index.module.scss';
import { ListItem } from '../ListItem/listItem';

/**
 * LinkList Props
 */
interface Props {
  /** リストのタイトル */
  title: LinkBox['boxName'];
  /** リンクリストのアイテム */
  listItems: LinkBox['boxLinks'];
}

/**
 * LinkListはリストのタイトルとリンクのリストを表示するコンポーネント
 * @param {Props} props - リストのタイトルとリンクのリスト
 * @returns {JSX.Element} - リストのタイトルとリンクのリストを含む要素
 */
export const LinkList: React.FC<Props> = ({ title, listItems }) => {
  return (
    <div className={styles.seoFooterLink}>
      <Text
        as="h3"
        weight="bold"
        size="16"
        className={styles.seoFooterLink_title}
      >
        {title}
      </Text>
      <ListItem linkItems={listItems} />
    </div>
  );
};
